import { api } from 'services/api/baseBackendAPI';

export const referenceApi = api.injectEndpoints({
  endpoints: (build) => ({
    summarizeNotes: build.mutation({
      query: (options) => ({
        url: `references/summarizeNotes`,
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        const tags = ['References', 'Fund Detail'];
        return tags;
      },
    }),

    addReference: build.mutation({
      query: (options) => ({
        url: `references/add-reference`,
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        const tags = [
          'References',
          'Fund Detail',
          ...(result?.id ? [{ type: 'References', id: result.id }] : []),
        ];
        return tags;
      },
    }),

    getAllReference: build.query({
      query: (fund_id) => ({
        url: `references/get-references/${fund_id}`,
        method: 'GET',
      }),
      providesTags: (result, error, fund_id) => {
        if (result && Array.isArray(result.data)) {
          const referencesArray = result.data;
          const tags = [
            ...referencesArray.map((reference) => ({
              type: 'References',
              id: reference.reference_id,
            })),
            'References',
          ];
          return tags;
        }
        const fallbackTags = ['References'];
        return fallbackTags;
      },
    }),

    getIndvReference: build.query({
      query: (options) => ({
        url: `references/get-indv-reference/${options.ref_id}`,
        method: 'GET',
        data: options,
      }),
      providesTags: (result, error, arg) => {
        if (result) {
          const tags = [
            {
              type: 'References',
              id: result.reference_id,
            },
            'References',
          ];
          return tags;
        }
        const fallbackTags = ['References'];
        return fallbackTags;
      },
    }),

    editReference: build.mutation({
      query: (options) => ({
        url: `references/edit-reference`,
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        const tags = [
          'References',
          'Fund Detail',
          {
            type: 'References',
            id: arg.reference_id,
          },
        ];
        return tags;
      },
    }),

    upsertReference: build.mutation({
      query: (options) => ({
        url: `references/upsert-reference`,
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        const baseTags = ['References', 'Fund Detail'];

        if (result?.data?.data?.reference_id) {
          baseTags.push({
            type: 'References',
            id: result.data.data.reference_id,
          });
        }
        return baseTags;
      },
    }),

    deleteReference: build.mutation({
      query: (options) => ({
        url: `references/delete-reference`,
        method: 'POST',
        data: options,
      }),
      invalidatesTags: (result, error, arg) => {
        const tags = [
          'References',
          'Fund Detail',
          {
            type: 'References',
            id: arg.reference_id,
          },
        ];
        return tags;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useAddReferenceMutation,
  useGetAllReferenceQuery,
  useGetIndvReferenceQuery,
  useEditReferenceMutation,
  useDeleteReferenceMutation,
  useUpsertReferenceMutation,
  useSummarizeNotesMutation,
} = referenceApi;
